import {
  clearAccountReturnIntent,
  getAccountReturnIntent,
  getPendingClaim,
  removePendingClaim,
  safeReturnPath,
} from "@/lib/accountStorage";

export function accountClaimErrorKind(error) {
  const status = error?.response?.status;
  if (status === 401 || status === 403) return "authentication";
  if (status === 404) return "invalid";
  if (status === 409) return "conflict";
  return "network";
}

export async function continuePendingClaim(claimResult, fallbackReturnTo = "/account/results") {
  const intent = getAccountReturnIntent();
  const returnTo = safeReturnPath(intent?.returnTo, safeReturnPath(fallbackReturnTo));
  const claim = intent?.claimCode ? getPendingClaim(intent.claimCode) : null;

  if (!claim) {
    clearAccountReturnIntent();
    return { attempted: false, claimed: false, returnTo };
  }

  try {
    const response = await claimResult(claim.anonymousCode, claim.claimToken);
    removePendingClaim(claim.anonymousCode);
    clearAccountReturnIntent();
    return { attempted: true, claimed: true, returnTo, response };
  } catch (error) {
    const errorKind = accountClaimErrorKind(error);
    if (errorKind === "invalid") removePendingClaim(claim.anonymousCode);
    clearAccountReturnIntent();
    return { attempted: true, claimed: false, returnTo, errorKind };
  }
}
